<div class="inline-flex flex-row items-center text-3xl" [formGroup]="valueStore">
  <input
    class="border-0 border-b-2 border-solid border-[rgba(0,21,74,0.3)] text-3xl outline-none focus:border-[#00154a]"
    formControlName="month"
    inputmode="numeric"
    placeholder="MM"
    size="2"
    maxlength="2"
    (focusout)="handleLostFocus(valueStore.controls.month, 1, 12)"
    (input)="handleInput($event, valueStore.controls.month, dayInput)"
    (keydown.enter)="onKeydownEnter()"
    #month
  />
  /
  <input
    class="border-0 border-b-2 border-solid border-[rgba(0,21,74,0.3)] text-3xl outline-none focus:border-[#00154a]"
    formControlName="day"
    inputmode="numeric"
    placeholder="DD"
    size="2"
    maxlength="2"
    (focusout)="handleLostFocus(valueStore.controls.day, 1, 31)"
    (input)="handleInput($event, valueStore.controls.day, yearInput)"
    #day
    (keydown.enter)="onKeydownEnter()"
    #month
  />
  /
  <input
    class="border-0 border-b-2 border-solid border-[rgba(0,21,74,0.3)] text-3xl outline-none focus:border-[#00154a]"
    formControlName="year"
    inputmode="numeric"
    placeholder="YYYY"
    size="4"
    maxlength="4"
    (input)="handleInput($event, valueStore.controls.year, null)"
    #year
    (keydown.enter)="onKeydownEnter()"
    #month
  />
</div>
